import { createTranslations } from '@npco/utils-translations'

export const billingReviewTranslations = createTranslations({
  billingReviewTitle: 'Billing',
  billingStartPeriodLabel: 'Billing Start Period',
  amountToBeChargedLabel: 'Amount to be Charged',
})
